export default {
	'dateTime.ago': 'ago',
	'dateTime.am': 'am',
	'dateTime.apr': 'Apr',
	'dateTime.april': 'April',
	'dateTime.aug': 'Aug',
	'dateTime.august': 'August',
	'dateTime.both': 'both',
	'dateTime.calendar': 'calendar',
	'dateTime.day': 'day',
	'dateTime.dec': 'Dec',
	'dateTime.december': 'December',
	'dateTime.decade': 'decade',
	'dateTime.feb': 'Feb',
	'dateTime.february': 'February',
	'dateTime.fri': 'Fri',
	'dateTime.friday': 'Friday',
	'dateTime.hour': 'hour',
	'dateTime.jan': 'Jan',
	'dateTime.january': 'January',
	'dateTime.july': 'July',
	'dateTime.jun': 'Jun',
	'dateTime.june': 'June',
	'dateTime.mar': 'Mar',
	'dateTime.march': 'March',
	'dateTime.may': 'May',
	'dateTime.minute': 'minute',
	'dateTime.mon': 'Mon',
	'dateTime.monday': 'Monday',
	'dateTime.nov': 'Nov',
	'dateTime.november': 'November',
	'dateTime.number': 'number',
	'dateTime.oct': 'Oct',
	'dateTime.october': 'October',
	'dateTime.pm': 'pm',
	'dateTime.sat': 'Sat',
	'dateTime.saturday': 'Saturday',
	'dateTime.sep': 'Sep',
	'dateTime.september': 'September',
	'dateTime.sun': 'Sun',
	'dateTime.sunday': 'Sunday',
	'dateTime.thu': 'Thu',
	'dateTime.thursday': 'Thursday',
	'dateTime.tue': 'Tue',
	'dateTime.tuesday': 'Tuesday',
	'dateTime.utc': 'UTC',
	'dateTime.wed': 'Wed',
	'dateTime.wednesday': 'Wednesday',
	'dateTime.week': 'week',
	'dateTime.year': 'year'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/date-time.js